export default "/react/logoCallibri-af5db7ba.png";